import { Link, Stack, Text } from "basis";
import { Product } from "library/hooks/types";
import styles from "./contact-section.module.scss";

interface Props {
  className?: string;
  product: Product;
}

const contactUsAu = "https://latitudefs.zendesk.com/hc/en-au/";
const contactUsNz = "https://gemfinance.zendesk.com/hc/en-nz/";

export const ContactSection = ({ className, product }: Props) => {
  const isNz = product.region === "NZ";

  return (
    <div className={className}>
      <div className={styles.section}>
        <Stack gap="4">
          <Text as="h3" color="primary.blue.t100">
            <strong>General enquiries</strong>
          </Text>
          <Text>
            Need to{" "}
            <Link href={isNz ? contactUsNz : contactUsAu} newTab>
              contact us
            </Link>
            ? We're here to help!
          </Text>
          <Text>
            If you need to get something done quickly, our range of self service
            options across the Latitude App and Service Center are designed to
            make your life easier.
          </Text>
        </Stack>
      </div>
    </div>
  );
};
